import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-product-v2",
  templateUrl: "./product-v2.component.html",
  styleUrls: ["./product-v2.component.sass"],
})
export class ProductV2Component implements OnInit {
  constructor() {}

  ngOnInit(): void {}
  producto: any = {
    idItemEC: 503,
    TItemEC: "ITD",
    TItemECNom: "Items - Destacados (Carrusel)",
    idItem: 16712,
    Marca: "LENOVO",
    Codigo: "AEQ01",
    Nro: 971,
    NombreItm:
      'LAPTOP LENOVO V15 G2 AMD RYZEN 3-5300U, 8GB, 256GB SSD, 15.6" FHD GRIS',
    UniMed: "CJA",
    UniMedDeno: "CAJA",
    CodigoBarras: "75330",
    PV1: 1800,
    PV2: 1176,
    PV3: 1120,
    PV4: 1120,
    PV5: 0,
    PV6: 0,
    PorcDscto: "-35%",
    APedido: true,
    TED: 1,
    TipoIGV: "1",
    Mostrar: true,
    SaldoG: 0,
    OrdenIEC: 0,
    ClicCant: 102,
    ValCant: 6,
    ValSum: 18,
    ValProm: 3,
    Otros:
      '<TABLE><TBODY><TR><TH>FORMATO</TH><TD>LAPTOP (2 equipos)</TD></TR><TR><TH>MARCA</TH><TD>LENOVO</TD></TR><TR><TH>MODELO</TH><TD>V15 G2</TD></TR><TR><TH>PANTALLA</TH><TD>15.6" FHD 1920 x 1080 ANTI-GLARE</TD></TR><TR><TH>PROCESADOR</TH><TD>AMD RYZEN 3 5300U 2.60GHZ</TD></TR><TR><TH>MEMORIA</TH><TD>RAM 8GB DDR4 3200MHZ</TD></TR><TR><TH>NUMERO DE RANURAS</TH><TD>1</TD></TR><TR><TH>EXPANSION MAXIMA</TH><TD>12GB</TD></TR><TR><TH>DISCO DURO</TH><TD>256GB SSD M.2 NVMe</TD></TR><TR><TH>LECTOR DE MEMORIAS</TH><TD>4-EN-1 CARD READER</TD></TR><TR><TH>VIDEO</TH><TD>AMD CHIPSET RADEON GRAPHICS</TD></TR><TR><TH>SALIDAS</TH><TD>HDMI</TD></TR><TR><TH>CONECTIVIDAD</TH><TD>WIRELESS 802.11AC 2x2</TD></TR><TR><TH>BLUETOOTH</TH><TD>5.0</TD></TR><TR><TH>PARLANTE</TH><TD>STEREO SPEAKERS, 1.5W X2, DOLBY AUDIO</TD></TR><TR><TH>PUERTOS</TH><TD>COMBO AUDIO/MIC SI</TD></TR><TR><TH>TOUCHPAD</TH><TD>SI</TD></TR><TR><TH/><TD/></TR><TR><TH>PUERTOS</TH><TD>USB 2.0 1</TD></TR><TR><TH>USB 3.2 TIPO-A GEN 1</TH><TD>1</TD></TR><TR><TH>USB 3.2 TIPO-C GEN 1</TH><TD>1</TD></TR><TR><TH>BATERIA</TH><TD>INTEGRADA DE 38WH</TD></TR><TR><TH>IDIOMA DE TECLADO</TH><TD>ESPAÑOL</TD></TR><TR><TH>SISTEMA OPERATIVO</TH><TD>VERSION NO INCLUYE SISTEMA</TD></TR><TR><TH>GARANTIA :</TH><TD>12 MESES DEL REPRESENTANTE EN EL PERU</TD></TR><TR><TH/><TD/></TR></TBODY></TABLE>',
    ImagenP:
      "https://devscon.pe/novaplaza/datastorage/items/2fcbb973-ec55-4a15-a650-051bab483401.png",
    Habilitado: true,
    Filial: "RU",
    Usuario: "YURDAYP",
    FechaHoraReg: "2023-03-22T07:39:24.67",
    UsuarioMod: "DEVELOPER3",
    FechaHoraMod: "2023-04-20T15:44:21.39",
    imagenProducto: "",
    items_Img_List: [],
  };
}
